import apiClient from '@/core/api/client';

export interface RoleDto {
  _id?: string;
  id?: string;
  name: string;
  code: string;
  description?: string;
  permissions: string[];
  is_custom?: boolean;
  /** Portal whose users this role governs (custom roles are consultancy staff roles). */
  portal?: 'superadmin' | 'consultancy' | 'agent' | 'student';
  staff_count?: number;
  /** The Super Admin role always has full access. */
  locked?: boolean;
}

export interface MenuItemDto {
  _id?: string;
  id?: string;
  title: string;
  path: string;
  icon: string;
  role: 'superadmin' | 'consultancy' | 'agent' | 'student' | 'all';
  permission?: string | null;
  category?: string;
  sort_order: number;
  is_active?: boolean;
  is_system?: boolean;
}

export const rolesApi = {
  getRoles: () => apiClient.get('/superadmin/roles'),
  createRole: (dto: { name: string; code: string; description?: string; permissions: string[]; portal?: string }) =>
    apiClient.post('/superadmin/roles', dto),
  getRoleById: (id: string) => apiClient.get(`/superadmin/roles/${id}`),
  updateRole: (id: string, dto: { name?: string; description?: string; permissions?: string[] }) =>
    apiClient.put(`/superadmin/roles/${id}`, dto),
  deleteRole: (id: string) => apiClient.delete(`/superadmin/roles/${id}`),
  /** Pages and actions the role editor offers for a portal. */
  getAccessCatalog: (portal: 'consultancy' | 'agent' | 'student' | 'superadmin') =>
    apiClient.get(`/superadmin/access-catalog?portal=${portal}`),
};

export const menusApi = {
  getMyMenu: () => apiClient.get('/menus/my-menu'),
  getAllMenus: (role?: string) => apiClient.get('/superadmin/menus', { params: { role } }),
  createMenu: (dto: Omit<MenuItemDto, '_id' | 'id'>) => apiClient.post('/superadmin/menus', dto),
  updateMenu: (id: string, dto: Partial<MenuItemDto>) => apiClient.put(`/superadmin/menus/${id}`, dto),
  deleteMenu: (id: string) => apiClient.delete(`/superadmin/menus/${id}`),
  seedMenus: () => apiClient.post('/superadmin/menus/seed'),
};

